import ImportQuery from "../../domain/core/payments/ImportQuery";
import { ImportModel } from "../../domain/models/Import";
import { IQueryImportRepository } from "../../domain/ports/payments/IQueryImportRepository";
import QueryService from "../QueryService";

export class ImportQueryService
  extends QueryService<ImportModel>
  implements IQueryImportRepository
{
  public constructor(
    public baseURL: string,
    public pathname: string,
  ) {
    super(baseURL, pathname);
    this.api.defaults.headers.common.Accept = "application/json";
  }
}

const BASE_URL = process.env.NEXT_PUBLIC_FLUX_API_URL as string;

const importQuery = new ImportQuery(
  new ImportQueryService(BASE_URL, "imports"),
);

export { importQuery };
